import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agentMobileFilter'
})
export class AgentMobileFilterPipe implements PipeTransform {

  transform(value: any[], mobile: string): any[] {
    if (mobile !== '') {
      return value.filter(
        item => item.mobile.toLowerCase().indexOf(mobile.toLowerCase()) > -1)
    } else {
      return value;
    }
  }

}
